import React, { Fragment, useEffect } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { logout } from '../../actions/auth';
import Card from 'react-bootstrap/Card';
import CardGroup from 'react-bootstrap/CardGroup';
import { GrCodepen } from 'react-icons/gr';
import { FaUser } from 'react-icons/fa';
import Spinner from '../layout/Spinner';
import { FaRegBuilding } from 'react-icons/fa';
import { RiPlayCircleLine } from 'react-icons/ri';
import logo from '../../img/ascorel.png';
import { useTranslation } from 'react-i18next';
import { checkLicenseEntity } from '../../actions/license';
import { FaKey } from 'react-icons/fa';

const Dashboard = ({
  checkLicenseEntity,
  auth,
  auth: { user, loading },
  checkLicense
}) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (auth) {
      checkLicenseEntity();
    }
  }, [checkLicenseEntity, auth]);

  return (
    <section className="container">
      <Fragment>
        {loading || auth === null || user === null ? (
          <Spinner />
        ) : (
          <Fragment>
            <h4 className="p-3 mb-2 bg-ascorel text-white text-center">
              {t('dashboard')}
            </h4>
            {/* <p className="lead" style={{ marginTop: 50 }}>
          <i className="fas fa-user" /> Bienvenue
        </p> */}
            <div className="parent-flex">
              <div>
                <img src={logo} alt="logo" height="100" />
              </div>
              {/* <div className="child-left-auto">
                <Link to={`/user/${user._id}`}>
                  <button
                    className="btn btn-ascorel"
                    style={{ marginRight: '0rem' }}
                  >
                    Mon compte <FaUser />
                  </button>
                </Link>
              </div> */}
            </div>
            <CardGroup style={{ marginTop: 50 }}>
              {auth && auth.user.rights !== 'ADV' ? (
                <Card className="m-3 card-style-code">
                  <Link to={`/codes`} className="stretched-link">
                    <GrCodepen
                      size={96}
                      className="icon-center my-3"
                      color="grey"
                    />
                  </Link>
                  <Card.Body>
                    <Card.Title className="card-header-color-title">
                      {t('codes')}
                    </Card.Title>
                    {auth &&
                    auth.user &&
                    (auth.user.rights === 'admin' ||
                      auth.user.rights === 'admin_entity') ? (
                      <Card.Text className="card-header-color">
                        {t('code_lead')}
                      </Card.Text>
                    ) : (
                      <Card.Text className="card-header-color">
                        {t('code_lead_user')}
                      </Card.Text>
                    )}
                  </Card.Body>
                </Card>
              ) : (
                <Fragment></Fragment>
              )}
              {auth &&
              auth.user.rights !== 'ADV' &&
              (auth.user.rights === 'admin' || checkLicense) ? (
                <Card className="m-3 card-style-visio7 hide-mobile">
                  <Link to={`/virtualscreen/login`} className="stretched-link">
                    <RiPlayCircleLine
                      size={106}
                      className="icon-center my-3"
                      color="grey"
                    />
                  </Link>
                  <Card.Body>
                    <Card.Title className="card-header-color-title">
                      {t('support')}
                    </Card.Title>
                    <Card.Text className="card-header-color">
                      {t('support_lead')}
                    </Card.Text>
                  </Card.Body>
                </Card>
              ) : (
                <Fragment></Fragment>
              )}
              {(auth && auth.user.rights !== 'user' && checkLicense) ||
              (auth && auth.user.entity === 'admin') ? (
                <Card className="m-3 card-style-license">
                  <Link to={'/licenses'} className="stretched-link">
                    <FaKey
                      size={96}
                      className="icon-center my-3"
                      color="grey"
                    />
                  </Link>
                  <Card.Body>
                    <Card.Title className="card-header-color-title">
                      {t('licenses')}
                    </Card.Title>
                    <Card.Text className="card-header-color">
                      {t('license_lead')}
                    </Card.Text>
                  </Card.Body>
                </Card>
              ) : (
                <Fragment></Fragment>
              )}
              {auth &&
              auth.user &&
              (auth.user.rights === 'admin' ||
                auth.user.rights === 'admin_entity') ? (
                // <Fragment>
                <Card className="m-3 card-style-users">
                  <Link to={`/users`} className="stretched-link">
                    <FaUser
                      size={96}
                      className="icon-center my-3"
                      color="grey"
                    />
                  </Link>
                  <Card.Body>
                    <Card.Title className="card-header-color-title">
                      {t('users')}
                    </Card.Title>
                    <Card.Text className="card-header-color">
                      {t('users_lead')}
                    </Card.Text>
                  </Card.Body>
                </Card>
              ) : (
                <Fragment></Fragment>
              )}
              {auth && auth.user && auth.user.rights === 'admin' ? (
                // <Fragment>
                <Card className="m-3 card-style-entity">
                  <Link to={`/entities`} className="stretched-link">
                    <FaRegBuilding
                      size={96}
                      className="icon-center my-3"
                      color="grey"
                    />
                  </Link>
                  <Card.Body>
                    <Card.Title className="card-header-color-title">
                      {t('entities')}
                    </Card.Title>
                    <Card.Text className="card-header-color">
                      {t('entities_lead')}
                    </Card.Text>
                  </Card.Body>
                </Card>
              ) : (
                // </Fragment>
                <Fragment></Fragment>
              )}
            </CardGroup>
          </Fragment>
        )}
      </Fragment>
    </section>
  );
};

Dashboard.propTypes = {
  checkLicenseEntity: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  checkLicense: PropTypes.bool.isRequired
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  checkLicense: state.license.checkLicense
});

export default connect(mapStateToProps, {
  checkLicenseEntity,
  logout
})(Dashboard);
